<footer class="footer">
<!--  <div class="footer__inner">-->
<!--    <p class="gray">© ТСН Вернисаж, 2019</p>-->
<!--  </div>-->
</footer>
